import { Tune } from '@mui/icons-material';
import { Badge, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '~/components/Tooltip';

interface FilterToggleProps {
  active: boolean;
  onToggle: () => void;
}

export const FilterToggle = ({ active, onToggle }: FilterToggleProps) => {
  const { t } = useTranslation();

  return (
    // Wraps the badge so hovering the dot itself explains it; an empty title shows nothing.
    <Tooltip title={active ? t('common.filter.applied_tooltip') : ''}>
      <Badge
        invisible={!active}
        overlap="rectangular"
        sx={{ '& .MuiBadge-dot': { backgroundColor: 'primary.dark' } }}
        variant="dot"
      >
        <Button
          // The dot is not announced, so the name carries the applied state.
          aria-label={active ? t('common.filter.button_applied') : undefined}
          onClick={onToggle}
          startIcon={<Tune />}
          variant="outlined"
        >
          {t('common.filter.button')}
        </Button>
      </Badge>
    </Tooltip>
  );
};
